"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fallbackError = 'Something went wrong';
exports.default = errorInfo => {
    if (!errorInfo.details || !errorInfo.details.errors) {
        return [fallbackError];
    }
    else {
        return errorInfo.details.errors.map(e => e.errorDescription || e.message || fallbackError);
    }
};
//# sourceMappingURL=extractApiErrors.js.map